import { render, staticRenderFns } from "./BarberBookingControl.vue?vue&type=template&id=bf7ba0e0&scoped=true&"
import script from "./BarberBookingControl.vue?vue&type=script&lang=js&"
export * from "./BarberBookingControl.vue?vue&type=script&lang=js&"
import style0 from "./BarberBookingControl.vue?vue&type=style&index=0&id=bf7ba0e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7ba0e0",
  null
  
)

export default component.exports